export default __webpack_public_path__ + "static/media/mechanic-4.2b4fc0a9.jpg";